<template>
  <app-modal name="invoice-approve-list-modal" :title="params.title" width="60%" :esc-to-close="false"
    @before-open="beforeOpen" @before-close="beforeClose" :ok-text="params.okText" :ok-class="params.okClass"
    @on-ok="onOk" @on-cancel="onCancel">
    <div class="row">
      <div class="container-max-height-scroll-80" :class="{
        'col-lg-6' : errorInvoices.length > 0 && uploadInvoices.length > 0,
        'col-lg-12' : uploadInvoices.length === 0
      }" v-if="errorInvoices.length > 0">
        <h5 class="text-red"><i class="fal fa-exclamation-circle"></i>{{$t('invoice.invalidInvoice')}}: </h5>
        <p>{{$t('invoice.invalidApproveList')}}</p>
        <div class="row" v-if="errorInvoices.length > 0">
          <div class="col-md-12">
            <div class="invoice-list full-height">
              <div v-for="(invoice, index)  in errorInvoices" track-by="$index"
                @click="onClickErrorInvoice(invoice, index)" class="invoice-item">
                <div class="d-flex">
                  <div>
                    <div class="invoice-title">{{index + 1}} - {{invoice.invoice_number}}</div>
                    <div v-if="invoice.errorMessage" class="invoice-description red">{{invoice.errorMessage}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="uploadInvoices.length > 0" class="container-max-height-scroll-80" :class="{
        'col-lg-6' : errorInvoices.length > 0 && uploadInvoices.length > 0,
        'col-lg-12' : errorInvoices.length === 0
      }">
        <h5 class="text-green"><i class="fal fa-check"></i>{{$t('invoice.validInvoices')}}: </h5>
        <div class="row">
          <div class="col-md-12">
            <invoice-list :show-index="true" :show-filter="false" :allow-multi-select="false"
              :active-invoice="activeInvoice" :invoices="uploadInvoices" @on-click="onClickInvoice"></invoice-list>
          </div>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import InvoiceForm from '@/portal-components/invoice/invoice-form';
import InvoiceList from '@/portal-components/invoice/invoice-list';
import { mapActions } from 'vuex';

export default {
  name: 'InvoiceUploadModal',
  components: {
    InvoiceForm,
    AppModal,
    InvoiceList,
  },
  data() {
    return {

      title: this.$t('invoice.approved'),
      uploadInvoices: [],
      errorInvoices: [],
      invoiceList: [],
      activeInvoice: {},
      params: {
        title: '',
        okText: '',
        text: '',
      },
    };
  },
  computed: {},
  created() {
    // this.$bus.on('update-invoice-success', this.onUpdateInvoiceSuccess);
  },
  beforeDestroy() {
    // this.$bus.off('update-invoice-success', this.onUpdateInvoiceSuccess);
  },
  methods: {

    ...mapActions(['addErrorInvoices', 'setState']),
    onClickErrorInvoice(errorInvoice, index) {
      // this.$nextTick(() => {
      this.$modal.show('invoice-form-modal', {
        invoiceList: this.errorInvoices.filter((i, idx) => (idx === index)),
        currentIndex: 0,
      });
      // });
    },
    onUpdateInvoiceSuccess(payload) {
      this.errorInvoices = this.errorInvoices.filter(inv => inv.id !== payload.model.id);
      this.uploadInvoices = this.uploadInvoices.filter(inv => inv.id !== payload.model.id);
      if (this.uploadInvoices.length === 0 && this.errorInvoices.length === 0) {
        this.$modal.hide('invoice-approve-list-modal', { isOk: true });
      }
    },
    onClickInvoice(invoice, index) {
      this.activeInvoice = invoice;
      // this.$nextTick(() => {
      // this.$nextTick(() => {
      this.$modal.show('invoice-form-modal', {
        invoiceList: this.uploadInvoices.filter((i, idx) => (idx === index)),
        currentIndex: 0,
      });
      // });
      // });
    },
    getMissingField(invoice) {
      // return (invoice.buyer_address && invoice.buyer_name && invoice.buyer_taxcode && invoice.company_id && invoice.content
      //   && invoice.invoice_no && invoice.invoice_number && invoice.invoice_serial && invoice.issued_date && invoice.seller_address && invoice.seller_name && invoice.seller_taxcode
      //   // && (invoice.status == "WAIT_FOR_APPROVAL")
      //   && invoice.template_code && invoice.total_amount_with_tax && invoice.total_amount_without_tax)
      const text = `${this.$t('invoice.missing')} ${invoice.company_id ? '' : 'company_id,'} ${(invoice.seller_taxcode || invoice.buyer_taxcode) ? '' : 'buyer_taxcode or seller_taxcode,'} ${invoice.total_amount_with_tax ? '' : 'total_amount_with_tax,'}`;
      return text;
    },
    beforeOpen(params) {
      this.params = params;
      this.uploadInvoices = params.model.validInvoices;
      this.errorInvoices = params.model.invalidInvoices.map(i => ({
        ...i,
        errorMessage: this.getMissingField(i),
      }),
      );
      const errorInvoices = {};
      this.errorInvoices.forEach((errorInv) => {
        errorInvoices[errorInv.id] = errorInv.errorMessage;
      });
      // this.addErrorInvoices(errorInvoices);
      this.invoiceList = [
        ...this.errorInvoices,
        ...this.uploadInvoices,
      ];
    },
    onOk(model) {
      if (this.uploadInvoices.length > 0) {
        this.setState({
          invoiceList: this.errorInvoices.map((i) => { const { errorMessage, ...result } = i; return result; }),
          inProgressInvoiceList: this.errorInvoices.map((i) => { const { errorMessage, ...result } = i; return result; }),
        });
      }
      if (this.params.onOk) {
        this.params.onOk(model);
      }
      this.$modal.hide('invoice-approve-list-modal', { isOk: true });
    },
    onCancel() {
      this.invoiceList = [
        ...this.errorInvoices.map((i) => { const { errorMessage, ...result } = i; return result; }),
        ...this.uploadInvoices,
      ];
      if (this.params.onCancel) {
        this.params.onCancel();
      }
      this.$modal.hide('invoice-approve-list-modal', { isOk: false });
    },
    beforeClose(event) {
      if (!this.params.beforeClose) {
        return;
      }
      this.params.beforeClose(event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-approve-list-modal.vue